import { render, staticRenderFns } from "./Week.vue?vue&type=template&id=4bf5ecd8&scoped=true&lang=html&"
import script from "./Week.vue?vue&type=script&lang=js&"
export * from "./Week.vue?vue&type=script&lang=js&"
import style0 from "./Week.vue?vue&type=style&index=0&id=4bf5ecd8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5ecd8",
  null
  
)

export default component.exports